import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppTranslate, HttpLoaderFactory } from './app.translate';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { DataTablesModule } from 'angular-datatables';
import { CanModule, CannotModule } from './pipes/can.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { Ng2Rut } from 'ng2-rut';

// Router
import { AppRoutingModule } from './app-router.module';

// Services
import { SidebarService } from './services/sidebar.service';
import { ContainerService } from './services/container.service';
import { AlertControlService } from './services/alert-control.service';
import { HelperService } from './services/helpers.service';
import { PermissionGroupService } from './services/permissionGroup.service';
import { StorageService } from './storage.service';

// Pipes
import { SearchMenuPipe } from './pipes/search.pipe';

// Components
import { AppComponent } from './app.component';
import { LayoutDashboardComponent } from './layout/layout-dashboard/layout-dashboard.component';
import { LayoutCommunityComponent } from './layout/layout-community/layout-community.component';
import { LayoutHomeComponent } from './layout/layout-home/layout-home.component';
import { ToolbarComponent } from './layout/toolbar/toolbar.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { SidebarCommunityComponent } from './layout/sidebar-community/sidebar-community.component';
import { ModalSessionModule } from './controls/modal-session/modal-session.module';
import { UserService } from './services/user.service';
import { AuthGuard } from './services/auth-guard.service';
import { ModalCommunityModule } from './controls/modal-community/modal-community.module';
import { TranslationService } from './services/translation.service';
import { CommunityService } from './services/community.service';
import { AdministrationService } from './services/administration.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { SiteResolverService } from './services/site-resolver.service';
import { CommonExpenseGuardService } from './services/common-expense-guard.service';
import { CommonExpensesService } from './common-expense/report/common-expenses/common-expenses.service';
import { StatusProcessService } from './services/status-process.service';
import { ModalLockModule } from './controls/modal-lock/modal-lock.module';
import { PublicationsComponent } from './layout/publications/publications.component';
import { PublicationsService } from './services/publications.service';
@NgModule({
  declarations: [
    AppComponent,
    LayoutDashboardComponent,
    LayoutHomeComponent,
    ToolbarComponent,
    SidebarComponent,
    LayoutCommunityComponent,
    SidebarCommunityComponent,
    SearchMenuPipe,
    PublicationsComponent
  ],
  imports: [
    BrowserModule,
    CanModule,
    CannotModule,
    FormsModule,
    BrowserAnimationsModule,
    ModalSessionModule,
    ModalCommunityModule,
    ModalLockModule,
    AppRoutingModule,
    HttpClientModule,
    DataTablesModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    CurrencyMaskModule,
    Ng2Rut
  ],
  providers: [
    SidebarService,
    ContainerService,
    AlertControlService,
    PermissionGroupService,
    UserService,
    TranslationService,
    CommunityService,
    AdministrationService,
    AuthGuard,
    CommonExpenseGuardService,
    CommonExpensesService,
    StatusProcessService,
    GoogleAnalyticsService,
    SiteResolverService,
    PublicationsService,
    StorageService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    HelperService
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends AppTranslate {

  constructor(translate: TranslateService) {
    super(translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts